import Vue from 'vue'
import Vuex from 'vuex'
import answerTexts from '@/stores/answerTexts'
import questions from '@/stores/questions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      bg: false
    },
    answers: [],
    answerTexts,
    questions,
  },
  mutations: {
    SET_ANSWER: (state, answer) => {
      state.answers.push(answer)
    },
    SET_BG: (state, bg) => {
      state.config.bg = bg
    }
  },
  actions: {
    setAnswer: (context, answer) => {
      context.commit("SET_ANSWER", answer)
    },
    setBg: (context, bg) => {
      context.commit("SET_BG", bg)
    },
  },
  getters: {
    getQuestion: (state) => (key) => {
      return state.questions[key]
    },
    getAnswers: (state) => {
      return state.answers
    },
    actualQuestion: (state, getters) => {
      const answers = getters.getAnswers
      const answersLength = answers.length || 0
      if (answersLength >= state.questions.length) {
        return false;
      } else {
        return getters.getQuestion(answersLength)
      }
    },
    answerText: (state) => (key) => {
      return state.answerTexts[key];
    },
    getScore: (state, getters) => {
      const buenas = getters.getAnswers.filter(i => i.result === true).length
      const preguntas = state.questions.length
      const finales = state.answerTexts.length

      return {
        percentage: Math.floor((buenas / preguntas) * 100),
        scoreTextIndex: Math.floor((buenas / preguntas) * finales - 1) > 0 ? Math.floor((buenas / preguntas) * finales - 1) : 0
      }
    },
    getScoreTexts: (state, getters) => {
      const score = getters.getScore

      return getters.answerText(score.scoreTextIndex)
    }
  }
})
